/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEscalationTicketCommentsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetEscalationTicketCommentsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getEscalationTicketComments = (request: GetEscalationTicketCommentsRequest, options?: CashRequestOptions) => post<GetEscalationTicketCommentsRequest, GetEscalationTicketCommentsResponse>("/2.0/cash/get-escalation-ticket-comments", request, {...options, rejectOnError: true })